import { Component, OnInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ImageListResult } from '../../result/image-list-result';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import { ExtraService } from '../../common/api/extra.service';
import { UserService } from '../../common/api/user.service';
import { ImageHostingService } from '../../common/api/image-hosting.service';
import { ImageModel } from '../../common/model/image.model';

@Component({
    selector : 'app-poster-list',
    templateUrl : './poster-list.component.html',
    styleUrls : ['./poster-list.component.css'],
})
export class PosterListComponent implements OnInit {
  posters: ImageModel[];
  row = 20;
  page = 0;
  totalPage: number;
  totalElement: number;
  numberOfElements: number;
  result: ImageListResult = new ImageListResult();
  htmlText = '';
  pageStart: number;
  pageEnd: number;
  sort = 'C.STORED_DATE,DESC';
  convertName = '';

  url = environment.imageUrl;
  modalSrc = '';
  modalIndex: any;
  constructor(public router: Router, private imageService: ImageHostingService, private userService: UserService
    , private extraService: ExtraService ) {}

  ngOnInit() {
     this.getPosterList();
  }

  changePage(num) {
    if (num >= 0 && num <= this.totalPage) {
      this.page = num;
      this.getPosterList();
    }
  }

  changeRow() {
    this.page = 0;
    this.getPosterList();
  }

  changeSort() {
    this.getPosterList();
  }

  getPosterList() {
    this.imageService.getPosters(this.row, this.page, this.sort, 'poster').subscribe(data => {
      this.totalPage = data.totalPages;
      this.totalElement = data.totalElements;
      this.numberOfElements = data.numberOfElements;
      this.posters = data.content;
      this.pageStart = Math.floor(((this.page) / 10)) * 10 + 1;
      this.pageEnd = (this.pageStart + 9);
      if ( this.pageEnd > this.totalPage) {
        this.pageEnd = this.totalPage;
      }
    }, error => {
      if (error.status === 401) {
        alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
        this.userService.logout();
      } else {
        alert('오류가 발생했습니다.');
      }
    });
  }

  posterRemove(imageId: string) {
    if (confirm('삭제하시겠습니까?')) {
      this.imageService.removeImages(imageId)
        .subscribe(response => {
          if (response.status === 200) {
            this.changePage(this.page);
          }
        }, error => {
          if (error.status === 401) {
            alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
            this.userService.logout();
          } else {
            alert('오류가 발생했습니다.');
          }
        });
    }
  }

    changeModalSrc(src: string) {
      this.modalSrc = src;
    }

    getImageSrc(poster: ImageModel) {
      for (const i in this.posters) {
        if (this.posters[i].imageNo === poster.imageNo) {
          this.modalIndex = i;
          break;
        }
      }
      // return environment.imageUrl + "/images/" + poster.imageNo + "/view?convertType=extra&convertName=" + poster.convertName;
      return poster.link;
    }

    moveModalImage(num: number) {

      const maxSize: number = this.posters.length - 1;
      const minSize = 0;

      let index: number = Number(this.modalIndex) + num;
      if (index > maxSize) {
        index = 0;
      } else if (index < minSize) {
        index = maxSize;
      }

      this.changeModalSrc(this.getImageSrc(this.posters[index]));
    }

    paginationHandler(event: number) {
      this.page = event;
      this.getPosterList();
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/poster/list/poster-list.component.ts